/**
 * Форматирование дат и чисел для интерфейса.
 *
 * Всё время приходит с сервера в UTC строкой ISO, а показывается в часовом
 * поясе браузера. Это сознательный выбор для админки: человек разбирает
 * инцидент «полчаса назад» и думает в своём времени, а не в UTC. Там, где
 * важна абсолютная метка — в журналах, — рядом с относительным временем
 * стоит точное, в подсказке.
 */

const dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

const timeFormat = new Intl.DateTimeFormat('ru-RU', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'

  const date = new Date(iso)

  return Number.isNaN(date.getTime()) ? '—' : dateTimeFormat.format(date)
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—'

  const date = new Date(iso)

  return Number.isNaN(date.getTime()) ? '—' : timeFormat.format(date)
}

/**
 * «3 минуты назад». Для журналов это читается быстрее абсолютной метки:
 * вопрос почти всегда «давно ли», а не «когда именно».
 */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'

  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) return '—'

  const seconds = Math.round((Date.now() - date.getTime()) / 1000)

  if (seconds < 0) return 'только что'
  if (seconds < 45) return 'только что'
  if (seconds < 90) return 'минуту назад'

  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} ${plural(minutes, 'минуту', 'минуты', 'минут')} назад`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} ${plural(hours, 'час', 'часа', 'часов')} назад`

  const days = Math.round(hours / 24)
  if (days < 30) return `${days} ${plural(days, 'день', 'дня', 'дней')} назад`

  return dateTimeFormat.format(date)
}

/** Русские числительные: 1 минута, 2 минуты, 5 минут. */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100
  const last = abs % 10

  if (abs > 10 && abs < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one

  return many
}

export function formatUptime(seconds: number): string {
  if (seconds < 60) return `${seconds} с`

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} ${plural(minutes, 'минута', 'минуты', 'минут')}`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} ${plural(hours, 'час', 'часа', 'часов')}`

  const days = Math.floor(hours / 24)

  return `${days} ${plural(days, 'день', 'дня', 'дней')}`
}
